import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

export interface SmartToast {
    key: string;
    condition: boolean;
    message: string;
    title?: string;
    type: ToastType;
}

@Injectable({ providedIn: 'root' })
export class SmartToastService {
    private readonly _active = new Set<string>();

    constructor(private toastr: ToastrService) {}

    notify(input: SmartToast | SmartToast[]): void {
        const toasts = Array.isArray(input) ? input : [input];
        toasts.forEach(t => this._process(t));
    }

    /**
     * Shows the toast unconditionally without tracking the key.
     * Use for per-action-user blocks where the field is reset immediately after.
     */
    flash(message: string, type: ToastType, title?: string): void {
        this.toastr[type](message, title);
    }

    clearAll(): void {
        this._active.clear();
    }

    clearSection(sectionPrefix: string): void {
        this._active.forEach(k => {
            if (k.startsWith(sectionPrefix)) {
                this._active.delete(k);
            }
        });
    }

    private _process(toast: SmartToast): void {
        if (toast.condition && !this._active.has(toast.key)) {
            this.toastr[toast.type](toast.message, toast.title);
            this._active.add(toast.key);
        } else if (!toast.condition) {
            this._active.delete(toast.key);
        }
    }
}
